import React from 'react';

interface LoadingSpinnerProps {
  text?: string;
  className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  text = 'Loading...',
  className = ''
}) => {
  return (
    <div className={`flex items-center justify-center py-16 ${className}`}>
      <div className="flex items-center space-x-3">
        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-[#171717]" />
        <span className="text-[#888]">{text}</span>
      </div>
    </div>
  );
};
